// JavaScript Document
$(function(){
	//我的购物车
	$(".header .mycart").hover(function(){
		$(this).addClass("hover");
		$(this).find(".goods-list").show();
		},function(){
			$(this).removeClass("hover");
			$(this).find(".goods-list").hide();
			});

	//分类
//	$(".sc-submenu ul li").hover(function(){
//		var index= $(this).index();
//		$(this).addClass("hover");
//		$(this).find(".sc-submenu-all").show();
//	},function(){
//		$(this).removeClass("hover");
//		$(this).find(".sc-submenu-all").hide();
//		});	
//	
//	$(".sc-submenu").mouseleave(function(){
//		$(".sc-submenu").hide();
//	});
})


// WEBPACK FOOTER //
// ./static/js/db-main.js